import { takeEvery, call, put, select, fork } from 'redux-saga/effects';
import toast from 'next/lib/toast';
import * as actionTypes from 'constants/actionTypes';
import {
  replaceUser as replaceUserAction,
  USER_SYNCED,
  USER_META_UPDATED,
  USER_USAGE_PROPERTY_UPDATED,
} from 'actions/user';
import {
  selectUser,
  selectUserId,
  selectUserUsageProperties,
} from 'reducers/user';
import { reportError } from 'helpers/error-reporting';
import { syncFirebasePath } from 'sagas/firebase/internal-lib';
import * as firebase from 'sagas/firebase/lib';

function* replaceUser(data = {}, uid) {
  yield put(
    replaceUserAction({
      ...data,
      id: uid,
    })
  );
}

export function* syncUser({ payload: { uid } }) {
  yield fork(
    syncFirebasePath,
    `users/${uid}`,
    replaceUser,
    actionTypes.CANCEL_USER_SYNC,
    uid
  );
}

export function* flushUserMeta({ payload: { changes = {} } }) {
  try {
    const userId = yield select(selectUserId);
    const meta = yield select(selectUser);

    yield call(firebase.set, `users/${userId}/meta`, meta);
    if (!changes.lastSeenTimestamp || Object.keys(changes).length > 1) {
      yield call(toast.success, 'Profile saved.');
    }
  } catch (error) {
    yield call(toast.error, 'Please try again.');
    yield call(reportError, error, 'Profile changes failed to save');
  }
}

export function* flushUsageProperties() {
  try {
    const userId = yield select(selectUserId);
    const usageProperties = yield select(selectUserUsageProperties);

    yield call(
      firebase.set,
      `users/${userId}/usageProperties`,
      usageProperties
    );
  } catch (error) {
    yield call(reportError, error, 'Failed to update usage property');
  }
}

export function* user() {
  yield takeEvery(USER_SYNCED, syncUser);
  yield takeEvery(USER_META_UPDATED, flushUserMeta);
  yield takeEvery(USER_USAGE_PROPERTY_UPDATED, flushUsageProperties);
}

export default user;
